import React, { useEffect } from "react"
import CheckboxField from "@kit/design/checkbox-field"
import useForm, { Form } from "@kit/design/use-form"
import Button from "@kit/design/button"
import Stack from "@kit/design/stack"

const LinkTrackingUnsubscribeShow = ({
  accountName,
  redactedEmailAddress,
  token,
  interestTopics
}) => {
  const csrfToken = document.querySelector("meta[name=csrf-token]").content

  return (
    <div className="mx-auto my-12" style={{ maxWidth: 652 }}>
      <div className="p-10 bg-white text-gray-800 rounded-lg shadow-md">
        <h1 className="text-2xl text-gray-900 font-semibold">
          {accountName || "Unsubscribe"}
        </h1>

        {redactedEmailAddress != undefined ? (
          <p className="text-gray-900 text-base mt-6">
            Are you sure you want to unsubscribe {redactedEmailAddress} from
            these emails?
          </p>
        ) : (
          <p className="text-gray-900 text-base">
            Are you sure you want to unsubscribe from this list?
          </p>
        )}
        <UnsubscribeForm csrfToken={csrfToken} token={token} />
        <UpdatePreferencesForm token={token} interestTopics={interestTopics} />
      </div>
    </div>
  )
}

const UnsubscribeForm = ({ csrfToken, token }) => {
  return (
    <form action={`/${token}`} method="post">
      <input
        type="hidden"
        name="authenticity_token"
        value={csrfToken}
        readOnly={true}
      />
      <Button is="primary" type="submit" className="mt-6">
        Unsubscribe from all
      </Button>
    </form>
  )
}

const UpdatePreferencesForm = ({ token, interestTopics }) => {
  const handleCheckboxToggle = event => {
    const { id, checked } = event.target
    form.setValue(`interest_topics[${id}].subscribed`, checked)
  }

  const form = useForm({
    initialData: {
      token: token,
      interest_topics: interestTopics
    }
  })

  useEffect(() => {
    form.setValue("interest_topics", interestTopics)
  }, [interestTopics])

  return (
    <>
      {Object.keys(interestTopics).length > 0 && (
        <Form form={form} method="PUT" action={`/${token}/preferences`}>
          <h2 className="text-gray-800 font-semibold text-base mt-6 mb-6">
            You can change your preferences to only receive certain types of
            emails from me:
          </h2>

          <Stack spacing={4}>
            {interestTopics.map((topic, idx) => {
              return (
                <CheckboxField
                  key={idx}
                  id={`interest_topics[${idx}]`}
                  name={`interest_topics[${idx}][subscribed]`}
                  label={topic.name}
                  value={topic.subscribed}
                  onChange={handleCheckboxToggle}
                />
              )
            })}
          </Stack>
          <button
            className="mt-6 ck-btn bg-white border-gray-100 border text-sm font-semibold text-gray-800 hover:bg-gray-50 focus:outline-blue py-3 px-5 rounded"
            type="submit"
          >
            Update preferences
          </button>
        </Form>
      )}
    </>
  )
}

export default LinkTrackingUnsubscribeShow
